export const GA_KLUE_TEST_ACCOUNT = 'UA-47988303-6';
export const DEBUG_ANALYTICS = false;
